<section class="panel p-4">
  <div class="d-flex flex-wrap gap-3 align-items-end justify-content-between mb-3">
    <div>
      <h2 class="h5 mb-1">Auditoria</h2>
      <div class="text-secondary small">{{ resumoFiltro() }}</div>
    </div>
    <button type="button" class="btn btn-primary btn-padrao" (click)="recarregar()" [disabled]="carregando">
      <i class="bi bi-arrow-clockwise px-2"></i>
      {{ carregando ? 'Carregando' : 'Atualizar' }}
    </button>
  </div>

  <app-painel-filtros-auditoria
    [empregadores]="empregadores"
    [empregadorSelecionado]="empregadorSelecionado"
    [dataInicial]="dataInicial"
    [dataFinal]="dataFinal"
    [tipoSelecionado]="tipoSelecionado"
    [statusSelecionado]="statusSelecionado"
    [buscaFuncionario]="buscaFuncionario"
    [funcionariosFiltrados]="funcionariosFiltrados"
    [limite]="limite"
    [tiposAuditoria]="tiposAuditoria"
    [statusAuditoria]="statusAuditoria"
    [rotuloFuncionario]="rotuloFuncionario"
    [detalheFuncionario]="detalheFuncionario"
    (empregadorSelecionadoChange)="selecionarEmpregador($event)"
    (dataInicialChange)="alterarDataInicial($event)"
    (dataFinalChange)="alterarDataFinal($event)"
    (tipoSelecionadoChange)="alterarTipo($event)"
    (statusSelecionadoChange)="alterarStatus($event)"
    (buscaFuncionarioChange)="alterarBuscaFuncionario($event)"
    (selecionarFuncionario)="selecionarFuncionario($event)"
    (abrirModalFuncionario)="abrirModalFuncionarios()"
    (limiteChange)="alterarLimite($event)">
  </app-painel-filtros-auditoria>

  <app-grade-eventos-auditoria
    [eventos]="eventos"
    [carregando]="carregando"
    [pagina]="pagina"
    [tamanho]="limite"
    [totalElementos]="totalElementos"
    [totalPaginas]="totalPaginas"
    (paginaChange)="irParaPagina($event)"
    (verCaptura)="abrirCaptura($event)">
  </app-grade-eventos-auditoria>
</section>

<app-modal-captura-ponto
  [aberta]="capturaAberta"
  [carregando]="capturaCarregando"
  [url]="capturaUrl"
  [titulo]="capturaTitulo"
  [aviso]="capturaAviso"
  [erro]="capturaErro"
  (fechar)="fecharCaptura()">
</app-modal-captura-ponto>

<app-modal-pesquisa-funcionario
  [aberta]="modalFuncionariosAberta"
  [termo]="buscaFuncionarioModal"
  [funcionarios]="funcionariosModal"
  [rotuloItem]="rotuloFuncionario"
  [detalheItem]="detalheFuncionario"
  (termoChange)="buscaFuncionarioModal = $event"
  (selecionar)="selecionarFuncionario($event)"
  (limpar)="limparBuscaFuncionarioModal()"
  (fechar)="fecharModalFuncionarios()">
</app-modal-pesquisa-funcionario>
